// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.selectbtn[data-v-a186b676] {\n  font-size: 12px;\n  border-bottom: solid 2px #cccccc;\n  padding: 0px 32px 16px;\n  color: #cccccc;\n}\n.selectbtn--active[data-v-a186b676] {\n  color: #2680eb;\n  border-bottom: solid 2px #2680eb;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
